<script setup lang="tsx">
import http from '@/services/http'
import methodEditor from '@/stores/method-editor'

const editor = methodEditor()

async function cancel() {
	editor.isEditMode = false
}

async function save() {
	const ch = editor.getChanges()
	const smmdIDsFromMethods = ch.standardMethods.map((method) => method.id)
	const smmdIDsFromRules = ch.standardRules.map((rule) => rule.method_meta_data_id).filter((id) => id !== null)
	const smmdIDs = [...smmdIDsFromMethods, ...smmdIDsFromRules].filter((id) => id !== null)
	editor.changeCount = 0
	editor.isEditMode = false

	await http.post('api/editMethodMetaData', ch)
	await editor.refresh()

	const exportRequest = {
		smmdIDs: smmdIDs,
		isMethodEdit: true,
	}
	http.post(`/api/jira/startExport`, exportRequest)
}
</script>

<template>
	<div v-if="editor.isEditMode" class="container fixed-bottom mb-4">
		<div class="row">
			<div class="col"></div>
			<div class="col text-center">
				<div class="d-inline-flex justify-content-between toolbar text-nowrap">
					<button id="cancel-edit-methods-btn" type="button" class="btn btn-light me-3" @click="cancel">{{ $t('misc.cancel') }}</button>
					<button id="save-edit-methods-btn" type="button" class="btn btn-primary" @click="save" :disabled="!editor.canSave">
						{{ $t('misc.save') }}
						<template v-if="editor.changeCount > 0"> ({{ editor.changeCount }})</template>
					</button>
				</div>
			</div>
			<div class="col"></div>
		</div>
	</div>
</template>
